export const PROPERTY = {
  START_SAVING_OPPORTUNITY_PROPERTY: 'START_SAVING_OPPORTUNITY_PROPERTY',
  ERROR_SAVING_OPPORTUNITY_PROPERTY: 'ERROR_SAVING_OPPORTUNITY_PROPERTY',
  END_SAVING_OPPORTUNITY_PROPERTY: 'END_SAVING_OPPORTUNITY_PROPERTY'
};
